import React, { Component } from "react";
import api from "../../config/api";
import { connect } from "react-redux";
import {
  debitsSelectedComp,
  debitsSelectedIDsComp,
  openSnackComp,
  debitsComp,
  valueAmountComp,
  setSelectedUser,
  validaDebitsMessage
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, TablePagination, Fab, Tooltip } from "@material-ui/core";
import Footer from "../../components/Footer";
import MenuDebitsManager from "../../components/MenuDebitsManager";
import FilterDebitsManager from "../../components/FilterDebitsManager";
import { CardDebit } from "../../components/CardDebit";
import LoadingDefault from "../../components/LoadingDefault";
import Snackbar from "../../components/Snackbar";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import ButtonTypeName from "../../components/ButtonTypeName";
import { arrayRemoveItem } from "../../helper/arrayRemoveItem";
import { Dehaze, GridOn } from "@material-ui/icons/";
import { errorDefault } from "../../helper/errorDefault";
import { convertDebitsData } from "../../helper/convertDebitsData";
import Messages from "../../helper/resources/Messages";
import { convertBrazilianDateToISO } from "../../helper/convertDate";
import TablePaginationActions from "../../components/TablePaginationActions/TablePaginationActions";
import imgFilter from "../../assets/img/filter.svg";
import DrawerFilterDebits from "../../components/DrawerFilterDebits";
import HeadList from "../../components/HeadList";
import {ListDebit} from "../../components/ListDebit";
import Constants from "../../helper/resources/Constants";
import MenuDebitsAttendant from "../../components/MenuDebitsAttendant";
import validationPermission from "../../helper/validationPermission";
import { Print } from "@material-ui/icons/";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import { convertBrazilianStringDatoToIso } from "../../helper/convertDate";

const styles = () => ({
  container: {
    padding: "0px 30px 20px 30px",
    marginTop: "130px",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  menuIcon: {
    width: 30,
    marginRight: 7,
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  marginBottom: {
    marginBottom: 40,
  },
  inputsItem: {
    display: "flex",
  },
  cardContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
    marginTop: 5,
  },
  pagination: {
    //width: '55%',
    border: "none",
    margin: "0 auto",
  },
  IconeFabFilter: {
    backgroundColor: "#fff",
    color: "#0066b2",
    transition: "all .2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  loadingDivRel: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
});

let sizePage = window.innerWidth;
export class Debit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      debits: [],
      itensMenu: [],
      debitsSelected: [],
      isHovering: true,
      loadingDebits: false,
      loadingRel: false,
      errorMessage: "",
      errorLoadDebits: false,
      isNewPageInstance: true,
      lastSearchParams: "",
      rowsPerPage: 36,
      isInSelectionMode: false,
      page: 0,
      controllerDrawer: false,
      listingType: "card",
      params: {},
    };

    this.getDebits = this.getDebits.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  componentDidMount() {
    this.props.openSnackComp(false);
    this.props.debitsComp([]);
    this.props.debitsSelectedComp([]);
    this.props.debitsSelectedIDsComp([]);
    this.props.setSelectedUser("");
    this.getDebits();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.debitsSelected?.length !== this.state.debitsSelected?.length
    ) {
      this.setState({
        isInSelectionMode: this.state.debitsSelected?.length > 0,
      });
    }

    return null;
  }

  async getDebits(filterParams) {
    this.setState(
      {
        loadingDebits: true,
        errorMessage: "",
        errorLoadDebits: false,
        snackBarMessage: "",
        isNewPageInstance: false,
        debitsSelected: [],
        debits: [],
        itensMenu: [],
      },
      () => {
        this.props.openSnackComp(false);
        this.props.debitsComp([]);
        this.props.debitsSelectedComp([]);
        this.props.debitsSelectedIDsComp([]);
      }
    );

    try {
      let params = {
        tipo: filterParams.tipoDocumentoContribuinte,
        cpfCnpj: filterParams.numeroContribuinte,
        obterOcultados: "",
        vincendo: filterParams.vincendo,
        vencido: filterParams.vencido,
        exigibilidadeSuspensa: filterParams.exigibilidadeSuspensa,
        codigoTributo: filterParams.codigoTributo,
        codigoEventoLancamento: filterParams.codigoEventoLancamento,
        valorMinimo: filterParams.valorMinimo,
        valorMaximo: filterParams.valorMaximo,
        dataVencimentoMinima:
          filterParams.dataInicio !== null &&
          filterParams.dataInicio !== undefined
            ? convertBrazilianDateToISO(filterParams.dataInicio)
            : "",
        dataVencimentoMaxima:
          filterParams.dataFim !== null && filterParams.dataFim !== undefined
            ? convertBrazilianDateToISO(filterParams.dataFim)
            : "",
      };

      const debitsGroup = await api.get("Gestao/Debitos", { params });
      await this.getItensMenuDebits(params);

      this.setState({
        params,
      });
      let debitsList = [];
      if (debitsGroup.data !== null && debitsGroup.data !== undefined) {
        if (debitsGroup.data.length > 0) {
          //04/09
          //O banco está vindo com IdDebitos duplicados. Este código remove os duplicados.
          //Após este problema ser resolvido (back), apagar isso. De nada!
          const map = new Map();
          for (const item of debitsGroup.data) {
            if (!map.has(item.IdDebito)) {
              map.set(item.IdDebito, true);
              debitsList.push(item);
            }
          }
        }

        this.setState({
          debits: debitsList,
        });

        debitsList.forEach((item) => {
          convertDebitsData(item);

          if (this.state.checkAllExpiredDueDate && item.DebitoAtrasado) {
            this.handleGetCardSelected(item.IdDebito, true);
            item.CheckedDebt = true;
          }

          if (this.state.checkAllNearDueDateDebts && item.DebitoVincendo) {
            this.handleGetCardSelected(item.IdDebito, true);
            item.CheckedDebt = true;
          }
        });

        this.setState(
          {
            debits: debitsList,
            loadingDebits: false,
            errorLoadDebits: false,
          },
          () => {
            this.props.debitsComp(debitsList);
          }
        );
      }
    } catch (error) {
      let errorMessage = ""; // errorDefault(error);

      this.setState({
        errorMessage: errorMessage,
        errorLoadDebits: true,
        loadingDebits: false,
      });
    }
  }

  async getItensMenuDebits(params) {
    try {
      const itensMenuResponse = await api.get(
        "Gestao/ObterContribuintesDebitos",
        { params }
      );

      let itensMenuList = [];

      if (
        itensMenuResponse.data.length > 0 &&
        itensMenuResponse.status === 200
      ) {
        itensMenuList = itensMenuResponse.data;

        itensMenuList.forEach((item) => {
          item.Contribuintes.forEach((itemCont) => {
            itemCont.checked = true;
          });
        });
      }

      this.setState({
        itensMenu: itensMenuList,
      });
    } catch (error) {
      let errorMessage = errorDefault(error);

      this.setState({
        errorMessage: errorMessage,
      });
    }
  }

  handlePrintDebtsReport = async () => {
    let lstDebito = [];

    if (this.props.debitsValue?.length === 0) {
      this.setState({
        snackBarMessage: "Nenhum débito.",
      });
    } else {
      this.setState({
        loadingRel: true,
      });

      this.props.debitsValue.forEach((debit) => {
        lstDebito.push({
          ...debit,
          DataVencimento: convertBrazilianStringDatoToIso(debit.DataVencimento),
        });
      });
      try {
        const params = {
          TipoInscricao: this.state.params.tipo,
          Inscricao: this.state.params.cpfCnpj,
          NomeContribuinte: "",
          Tributo: this.state.params.codigoTributo,
          NomeTributo: "",
          DataVencimentoMinima: this.state.params.dataVencimentoMinima,
          DataVencimentoMaxima: this.state.params.dataVencimentoMaxima,
          ValorMinimo: this.state.params.valorMinimo,
          ValorMaximo: this.state.params.valorMaximo,
          SomenteVincendos: this.state.params.vincendo,
          SomenteVencidos: this.state.params.vencido,
          SomenteExigibilidadeSuspensa: this.state.params.exigibilidadeSuspensa,
          Debitos: [...lstDebito],
        };
        const ReportResponse = await api.post(
          "Gestao/ObterRelatorioDebitos",
          params
        );
        let pdf = "";

        if (ReportResponse.data !== null && ReportResponse.data !== undefined) {
          pdf = ReportResponse.data;

          this.setState({
            loadingRel: false,
          });

          var file = b64toBlob(pdf, "application/pdf");
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "EPrescription");
        }

        if (ReportResponse.data === null || ReportResponse.data === "") {
          this.setState({
            loadingRel: false,
          });
        }
      } catch (error) {
        this.setState({
          loadingRel: false,
        });
      }
    }
  };

  checkDebtsSelected = () => {
    const anyDebtsSelected = this.props.debitsSelectedIDsValue.length > 0;
    if (!anyDebtsSelected) {
      this.setState(
        {
          snackBarMessage: Messages.NENHUM_DEBITO_SELECIONADO,
          loadingDebits: false,
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }

    return anyDebtsSelected;
  };

  handleSearchDebts = (filterParams, validation) => {
    if (validation.isValid) {
      this.getDebits(filterParams);

      this.setState(
        {
          lastSearchParams: filterParams,
        },
        () => {
          this.props.setSelectedUser({
            numeroInscricao: filterParams.numeroContribuinte,
            tipoInscricao: filterParams.tipoDocumentoContribuinte,
          });
        }
      );
    } else {
      if (validation.errorMessage !== "") {
        this.setState(
          {
            snackBarMessage: validation.errorMessage,
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    }
  };

  handleShowDebt = async () => {
    if (this.checkDebtsSelected()) {
      try {
        let bodyRequest = {
          Debitos: this.props.debitsSelectedIDsValue,
        };

        const OcultarDebitoResponse = await api.put(
          "Gestao/ReexibirDebitos",
          bodyRequest
        );

        if (OcultarDebitoResponse.data.EhValida) {
          this.setState(
            {
              loadingDAM: false,
              errorDAM: false,
            },
            () => {
              this.getDebits(this.state.lastSearchParams);
            }
          );
        } else {
          this.setState({
            snackBarMessage:
              OcultarDebitoResponse.data.Erros[0] ||
              "Ocorreu um erro na operação.",
            loadingDebits: false,
          });
          this.props.openSnackComp(true);
        }
      } catch (error) {
        this.setState({
          loadingDebits: false,
        });
      }
    }
  };

  handleHideDebt = async () => {
    if (this.checkDebtsSelected()) {
      try {
        let bodyRequest = {
          Debitos: this.props.debitsSelectedIDsValue,
        };
        const OcultarDebitoResponse = await api.post(
          "Gestao/OcultarDebitos",
          bodyRequest
        );

        if (OcultarDebitoResponse.data.EhValida) {
          this.setState(
            {
              loadingDAM: false,
              errorDAM: false,
            },
            () => {
              this.getDebits(this.state.lastSearchParams);
            }
          );
        } else {
          this.setState({
            snackBarMessage:
              OcultarDebitoResponse.data.Erros[0] ||
              "Ocorreu um erro na operação.",
            loadingDebits: false,
          });
          this.props.openSnackComp(true);
        }
      } catch (error) {
        this.setState({
          loadingDebits: false,
        });
      }
    }
  };

  checkNoHiddenDebtsSelected = () => {
    let selectedDebits = this.state.debits.filter((x) =>
      this.state.debitsSelected.includes(x.IdDebito)
    );
    const isHiddenDebtSelected = selectedDebits.some((debit) => debit.Ocultado);
    if (isHiddenDebtSelected) {
      this.setState(
        {
          snackBarMessage: Messages.DEBITO_OCULTADO_SELECIONADO,
          loadingDebits: false,
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }

    return !isHiddenDebtSelected;
  };

  handleEmitirDAM = () => {
    if (this.checkDebtsSelected() && this.checkNoHiddenDebtsSelected()) {
      let debits = this.state.debits.filter((x) =>
        this.state.debitsSelected.includes(x.IdDebito)
      );

      this.validaDebits(debits).then((response) => {
        this.props.debitsSelectedComp(response);
        var debitsId = [];
          response.forEach(item => debitsId.push(item.IdDebito));
        this.props.debitsSelectedIDsComp(debitsId);
        
        const totalAmount = response.reduce(
          (previous, current) => previous + current.ValorPagar,
          0
        );
        
        this.props.valueAmountComp(totalAmount);
        
        const { from } = this.props.location.state || {
          from: { pathname: "/debitos-selecionados" },
        };
        this.props.history.push(from);
      });
    }
  };
  
  async validaDebits(debitsSelected) {
    var debits = [];

    debitsSelected.forEach((debit) => {
      debits.push(debit.IdDebito);
    });

    const retorno = await api.post("Debitos/ValidarDebitosConferencia", [
      ...debits,
    ]);


    if (!retorno?.data) {
      this.props.validaDebitsMessage("Erro ao validar Débitos.");
      return debitsSelected;
    }

    if (retorno.data?.Retorno?.length !== debitsSelected.length) {
      const { Retorno } = retorno?.data;

      var debitosValidados = [];
      debitsSelected.forEach((debit) => {
        if (Retorno.indexOf(debit.IdDebito) >= 0) debitosValidados.push(debit);
      });

      this.props.validaDebitsMessage(
        "Alguns débitos foram excluídos devido a divergência no SAT."
      );

      return debitosValidados;
    } else {
      return debitsSelected;
    }
  }

  handleGetCardSelected = (id, checked) => {
    if (checked) {
      this.setState(
        (prevState) => ({
          debitsSelected: [...prevState.debitsSelected, id],
          isHovering: !this.state.isHovering,
        }),
        () => {
          this.props.debitsSelectedIDsComp(this.state.debitsSelected);
        }
      );
    } else {
      let updatedSelectedItems = this.state.debitsSelected;
      updatedSelectedItems = arrayRemoveItem(updatedSelectedItems, id);

      this.setState(
        {
          debitsSelected: updatedSelectedItems,
        },
        () => {
          this.props.debitsSelectedIDsComp(updatedSelectedItems);
        }
      );
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    this.setState({ page: 0 });
  };

  handleMenuDebitsFilter = (itens) => {
    if (itens.length > 0) {
      let listFiltered = this.state.debits.filter((item) =>
        itens.includes(item.Contribuinte.NumInscricao)
      );

      this.setState({ page: 0, controllerDrawer: false }, () => {
        this.props.debitsComp(listFiltered);
      });
    } else {
      this.setState({ page: 0, controllerDrawer: false }, () => {
        this.props.debitsComp([]);
      });
    }
  };

  toggleDrawer = (controller) => {
    this.setState({
      controllerDrawer: controller,
    });
  };

  handleChangeApresentation = (type) => {
    this.setState({
      listingType: type,
    });
  };

  render() {
    const { classes, profile, user } = this.props;
    const {
      isNewPageInstance,
      loadingDebits,
      errorLoadDebits,
      itensMenu,
      snackBarMessage,
      rowsPerPage,
      listingType,
      loadingRel,
    } = this.state;

    return (
      <div>
        <Grid container className={classes.container}>
          {profile === Constants.PERFIL_ATENDENTE ? (
            <MenuDebitsAttendant />
          ) : (
            <MenuDebitsManager />
          )}

          <Box width={1}>
            <FilterDebitsManager
              user={user}
              LoadingDebits={loadingDebits}
              GetDebtsManager={this.handleSearchDebts}
              HasRequiredFields={true}
            />
          </Box>

          {this.state.debits.length > 0 && (
            <Box width={1} marginTop={2}>
              <Box display="flex" justifyContent="space-between">
                <Grid flex spacing={3} container justifyContent="flex-start">
                  <Grid item>
                    <Fab onClick={() => this.toggleDrawer(true)}>
                      <Tooltip title="Filtrar">
                        <img
                          style={{ height: "25px", marginTop: "6px" }}
                          src={imgFilter}
                          alt="Imagem do menu filtrar"
                        />
                      </Tooltip>
                    </Fab>
                  </Grid>
                  <Grid item>
                    {listingType === "lista" ? (
                      <Fab
                        className={classes.IconeFabFilter}
                        onClick={() => this.handleChangeApresentation("card")}
                      >
                        <Tooltip placement="top" title="Apresentação em Cards">
                          <GridOn />
                        </Tooltip>
                      </Fab>
                    ) : (
                      <Fab
                        className={classes.IconeFabFilter}
                        onClick={() => this.handleChangeApresentation("lista")}
                      >
                        <Tooltip placement="top" title="Apresentação em Lista">
                          <Dehaze />
                        </Tooltip>
                      </Fab>
                    )}
                  </Grid>
                  <Grid item>
                    <Fab
                      onClick={this.handlePrintDebtsReport}
                      className={classes.IconeFabFilter}
                    >
                      <Tooltip placement="top" title="Relátorio de Débitos">
                        {loadingRel ? (
                          <div className={classes.loadingDivRel}>
                            <LoadingDefault typeLoading={"debits"} />
                          </div>
                        ) : (
                          <Print />
                        )}
                      </Tooltip>
                    </Fab>
                  </Grid>
                </Grid>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {validationPermission(user, "UC011") && (
                    <>
                      <ButtonTypeName
                        id="exibirBtn"
                        typeButton={11}
                        backgroundTransparent={true}
                        onClick={this.handleShowDebt}
                      />
                      <ButtonTypeName
                        id="ocultarBtn"
                        typeButton={12}
                        onClick={this.handleHideDebt}
                      />
                    </>
                  )}
                  {validationPermission(user, "UC003") && (
                    <ButtonTypeName
                      id="emitirDAMBtn"
                      typeButton={1}
                      onClick={this.handleEmitirDAM}
                    />
                  )}
                </div>
              </Box>
              <DrawerFilterDebits
                controllerDrawer={this.state.controllerDrawer}
                toggleDrawer={this.toggleDrawer}
                itensMenu={itensMenu}
                handleMenuDebitsFilter={this.handleMenuDebitsFilter}
              />
            </Box>
          )}

          {snackBarMessage !== "" && (
            <Snackbar message={snackBarMessage} openSnackValue={true} />
          )}

          {loadingDebits && (
            <div className={classes.loadingDiv}>
              <LoadingDefault typeLoading={"card"} />
            </div>
          )}

          {!isNewPageInstance &&
            this.props.debitsValue.length === 0 &&
            !loadingDebits &&
            !errorLoadDebits && (
              <ContentNotLoaded
                message={Messages.NENHUM_DEBITO_ENCONTRADO_SISTEMA}
              />
            )}

          {this.props.debitsValue.length > 0 && (
            <div className={classes.cardContainer}>
              {listingType === "lista" && <HeadList />}

              <Grid container>
                {listingType === "card"
                  ? (rowsPerPage > 0
                      ? this.props.debitsValue.slice(
                          this.state.page * rowsPerPage,
                          this.state.page * rowsPerPage + rowsPerPage
                        )
                      : this.props.debitsValue
                    ).map((item) => {
                      if (
                        this.props.profile === Constants.PERFIL_ATENDENTE &&
                        item.Ocultado === true
                      ) {
                        return null;
                      }
                      return (
                        <CardDebit
                          key={item?.IdDebito}
                          classes={classes}
                          handleGetCardSelected={this.handleGetCardSelected}
                          contentCard={item}
                          typeCard={"debits"}
                          selectionModeActive={this.state.isInSelectionMode}
                        />
                      );
                    })
                  : this.props.debitsValue.map((item) => {
                      if (
                        this.props.profile === Constants.PERFIL_ATENDENTE &&
                        item.Ocultado === true
                      ) {
                        return null;
                      }
                      return (
                        <ListDebit
                          key={item?.IdDebito}
                          classes={classes}
                          handleGetCardSelected={this.handleGetCardSelected}
                          checkDebts={item?.CheckedDebt}
                          contentCard={item}
                          typeCard={"debits"}
                          selectionModeActive={this.state.isInSelectionMode}
                        />
                      );
                    })}
              </Grid>
              {listingType === "card" && (
                <TablePagination
                  className={classes.pagination}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from} - ${to} de ${count}`
                  }
                  labelRowsPerPage={sizePage <= 575 ? null : "Itens por página"}
                  rowsPerPageOptions={sizePage <= 575 ? [] : [4, 8, 12, 36]}
                  colSpan={3}
                  count={this.props.debitsValue.length}
                  rowsPerPage={rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              )}
            </div>
          )}
        </Grid>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    debitsValue: store.cardDebitState.debitsValue,
    debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
    debitsSelectedIDsValue: store.cardDebitState.debitsSelectedIDsValue,
    openSnackValue: store.cardDebitState.openSnackValue,
    profile: store.auth.profile,
    user: store.auth,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      debitsComp,
      debitsSelectedComp,
      debitsSelectedIDsComp,
      openSnackComp,
      valueAmountComp,
      setSelectedUser,
      validaDebitsMessage
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(Debit)
);
